import { useTranslation } from "react-i18next";
import { Col, Row } from 'react-bootstrap';
import PageTitle from "../../../layouts/PageTitle";
import ScoreHistory from "../../../components/Custom/Gamification/Score/ScoreHistory";

const ScoreList = () => {

    const { t } = useTranslation();

    return (
        <>
            <PageTitle activeMenu={t('gamification.score')} motherMenu={t('gamification.label')} />
            <Row>
                <Col className="col-md-12">
                    <ScoreHistory />
                </Col>
            </Row>
        </>
    );
}

export default ScoreList;